import env from './.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    environmentKey: 'stratus',
    production: false,
    stratus: true,
    version: env.npm_package_version + '-dev',
    nodeBaseURL: '/api/',
    checkProhibitedCountryURL: 'https://1868vm5fzh.execute-api.us-east-1.amazonaws.com/prod/CheckProhibitedCountry',
    baseS3URL: 'https://bes-fenton-test-yourcardhub.s3.amazonaws.com',
    //walletURL: 'https://apps.myprepaidcenter.com/provision-egift?requestor=MPC&account=${proxyCardNumber}&verification=${cardLastFour}',
    walletURL: 'https://apps.myprepaidcenter.com/provision-egift?requestor=MPC&token=${token}',
    defaultLang: 'en-US',
    loginExpireWarningSeconds: 15,
    showLoginExpirationTimer: false,
    logConfig() {
        return {
            serverLoggingUrl: 'https://qa-ych.myprepaidcenter.com/api/log',
            level: NgxLoggerLevel.TRACE,
            serverLogLevel: NgxLoggerLevel.OFF,
            disableConsoleLogging: false,
        };
    },
    trustedLinkPatterns: [
        /data:image/,
        /^https?\:\/\/localhost\:4200/,
        /^https?\:\/\/(.*?)yourcardhub.com/,
        /^https?\:\/\/[^\/\?\#]*blackhawknetwork\.com/,
        /^https?\:\/\/[^\/\?\#]*intelispend-staging\.com/,
        /^https?\:\/\/bes-fenton-test-yourcardhub\.s3\.amazonaws\.com/,
        /^https?\:\/\/(.*?)myprepaidcenter.com/,
        /^https?\:\/\/(.*?)blackhawknetwork.com/,
        /^https?\:\/\/embed\.widencdn\.net\/download\/blackhawknetwork\//,
        /javascript:void/,
    ],
    useNewCardDetail: true,
    trustEVKey: '4c5bd5270c844831a15d0272b3b6fe77',
    trustEVURL: 'https://cdn-us.trustev.com/trustev.min.js',
    webPackConfig: true,
};
